import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getAllDataTypes, getDataTypeMappings, loadAllDataTypeMappings, loadAllDataTypes } from "../../store/dataTypes";
import XMLParser from "react-xml-parser";
import { getFieldData } from "../../../services/appService";
import { generatedContractReceived, getGeneratedDocument, loadGenerateContractDocument } from "../../store/ddrmsDocument";
import AddDataTypeMapping from "./AddDataTypeMapping";
import moment from "moment";
import { getLocalDocUploadSasUrl, getLocalGeneratedDocUploadSasUrl, uploadGeneratedLocalDocument, uploadLocalDocument } from "../../store/documents";
import { getCurrentUser } from "../../store/auth";
import { get, set, size } from "lodash";
import { getAlert } from "../../../services/appAlerts";
import { uploadFileToBlob } from "../../../services/blobUploadService";

const DataMapping = (props) => {
    const { app, handleCloseMapping, selectedObj, workflowTask, applicantObj, uploadType, viewType } = props;
    const [allMapObjects, setAllMapObjects] = useState([]);
    const [dataTypeMapping, setDataTypeMapping] = useState([]);
    const [newMappingShowHide, setNewMappingShowHide] = useState(false);
    const [btnProcessStatus, setBtnProcessStatus] = useState(false);
    const [saveBtnType, setSaveBtnType] = useState("");
    const [generatedBlob, setGeneratedBlob] = useState(null);


    const getGeneratedDocumentSelector = useSelector(getGeneratedDocument);
    const dataTypeMappingsSelector = useSelector(getDataTypeMappings);
    const localGeneratedDocUploadSasUrlSelector = useSelector(getLocalGeneratedDocUploadSasUrl);

    const dispatch = useDispatch();
    const currentUser = useSelector(getCurrentUser);

    const normalizeToPdfBlob = (doc) => {
        if (!doc) return null;
        if (doc instanceof Blob) {
            if (doc.type) return doc;
            return new Blob([doc], { type: "application/pdf" });
        }
        if (doc?.data instanceof Blob) {
            if (doc.data.type) return doc.data;
            return new Blob([doc.data], { type: "application/pdf" });
        }
        return new Blob([doc], { type: "application/pdf" });
    };

    useEffect(() => {
        dispatch(loadAllDataTypeMappings());
    }, []);

    useEffect(() => {
        let perfId = 0;
        let perfType = "";
        if (uploadType === "Subcontractor") {
            perfType = "Sub-Contractors"
        }
        else if (uploadType === "Candidate") {
            perfType = "candidate"
        } else if (uploadType === "Recruiter") {
            perfType = "Recruiter"
        }
        setDataTypeMapping(dataTypeMappingsSelector.filter(x => x.type === perfType));
    }, [dataTypeMappingsSelector])

    const handleGenerate = (btnType) => {
        setBtnProcessStatus(true);
        setSaveBtnType(btnType);
        var mapData = {};
        allMapObjects.map(item => {
            let ddValue = "";
            item.replaceDataTypes.filter(x => x.attValue !== "").map(v => {
                ddValue += v.attValue + (v.attCommaSeperated ? ", " : " ");
            });
            mapData[item.field] = ddValue;
        })
        var frmData = new FormData();
        frmData.append("ciid", workflowTask.ciid);
        frmData.append("docId", selectedObj.id);
        frmData.append("mapData", JSON.stringify(mapData));
        frmData.append("btnType", btnType);
        dispatch(loadGenerateContractDocument(frmData));
    }

    useEffect(() => {
        if (getGeneratedDocumentSelector) {
            let newFileName = "ipcs_document";
            if (selectedObj?.name)
                newFileName = selectedObj.name.replace(/\.docx$/, ".pdf");
            const normalizedBlob = normalizeToPdfBlob(getGeneratedDocumentSelector);
            if (!normalizedBlob || normalizedBlob.size === 0) {
                getAlert("Error", "Generated document is empty. Please try again.", "error");
                dispatch(generatedContractReceived(null));
                setBtnProcessStatus(false);
                setSaveBtnType("");
                return;
            }
            if (saveBtnType === "save") {
                saveLocalDocs(workflowTask, normalizedBlob, newFileName);
                const file = new File([normalizedBlob], newFileName, { type: normalizedBlob.type || "application/pdf" });
                setGeneratedBlob(file);
            }
            else
                downloadGeneratedDocument(normalizedBlob, newFileName);

            dispatch(generatedContractReceived(null));
            setBtnProcessStatus(false);
            setSaveBtnType("");
        }
    }, [getGeneratedDocumentSelector]);

    const saveLocalDocs = (workflowTask, blob, fileName) => {
        let wfTask = { ...workflowTask };
        //wfTaskObj.performerId = currentUser.id;

        if (viewType === "candidateList") {
            if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
                wfTask.performerId = applicantObj.recruiter.parentid
            else if (uploadType === "Subcontractor" && applicantObj?.subcontractor?.parentid)
                wfTask.performerId = applicantObj.subcontractor.parentid
            else if (uploadType === "Candidate" && applicantObj?.id)
                wfTask.performerId = applicantObj?.id
        }
        else if (applicantObj?.id) {
            wfTask.performerId = applicantObj?.id
        }

        const frmData = new FormData();
        frmData.append("message", "contract generated");
        frmData.append("workflowTask", JSON.stringify(wfTask));
        frmData.append("userId", currentUser.id);
        //const file = new File([blob], fileName, { type: blob.type });
        frmData.append('files', JSON.stringify([{ name: fileName, type: blob.type, size: blob.size }]));
        frmData.append("docType", "");
        frmData.append("updType", "");
        frmData.append("isPwd", "");
        dispatch(uploadGeneratedLocalDocument(frmData));
        getAlert("", "Contract generated successfully", "success");
    }

    useEffect(() => {
        console.log("localGeneratedDocUploadSasUrlSelector", localGeneratedDocUploadSasUrlSelector);
        if (localGeneratedDocUploadSasUrlSelector) {
            uploadFileToBlob(generatedBlob, localGeneratedDocUploadSasUrlSelector, (progress) => {
                console.log(`Upload progress: ${progress}%`);
                if (progress === 100) {
                    handleCloseMapping(saveBtnType);
                    setGeneratedBlob(null);
                }
            })
        }
    }, [localGeneratedDocUploadSasUrlSelector]);

    const downloadGeneratedDocument = (blob, fileName) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        getAlert("", "Document downloaded successfully, Check your downlaod folder", "success");
        handleCloseMapping(saveBtnType);
    }

    const handleAddNewMapping = () => {
        setNewMappingShowHide(!newMappingShowHide);
    }

    const handleChangeMapping = ({ currentTarget }) => {
        const ddMaps = dataTypeMapping.filter(x => x.id === parseInt(currentTarget.selectedOptions[0].value));
        if (ddMaps.length > 0) {
            const mpJs = JSON.parse(ddMaps[0].mappingJson);
            let att = "";
            let vl = "";
            if (applicantObj.partnerType) {
                att = applicantObj.partnerType;
                vl = applicantObj.fuid;
            }
            else {
                att = applicantObj.registrationType;
                vl = applicantObj.id;
            }

            const updMpjs = mpJs.map(x => {
                x.replaceDataTypes.map(d => {
                    if (d.attType === "currentDate" && d.attObj === "date") {
                        d.attValue = moment(new Date()).format("MM-DD-YYYY");
                    }
                    else if (d.attType === att && d.attObj === "id") {
                        d.attValue = vl;
                    }
                    else {
                        if (applicantObj.applications.length > 0) {
                            const appObj = applicantObj.applications[0];
                            const attValue = getFieldData(appObj.applicationData, d.attType.toLowerCase(), d.attObj);
                            d.attValue = attValue;
                        }
                        else {
                            d.attValue = "";
                        }
                    }
                    return d;
                })
                return x;
            })
            setAllMapObjects(updMpjs)
        }
    }

    const handleDeleteMappItem = (item) => {
        const ddMapps = [...allMapObjects];
        const index = ddMapps.findIndex(x => x.field === item.field);
        if (index > -1) {
            ddMapps.splice(index, 1);
            setAllMapObjects(ddMapps);
        }
    }

    return <>
        {selectedObj && <>
            <div className="col-md-12 border p-2 form-group">Document : <b>({selectedObj.id}) {selectedObj.name}</b></div>
        </>}

        {!newMappingShowHide &&
            <div className="row">
                <div className="col-md-12 form-group">
                    <label htmlFor="ddMapping" className="form-control-label">Existing DataType Mapping</label>
                    <button className="btn btn-link btn-sm float-right mr-0 pr-0" onClick={handleAddNewMapping}>Add New Mapping</button>
                    <select
                        className="form-control"
                        name="ddMapping"
                        id="ddMapping"
                        onChange={handleChangeMapping}
                    >
                        <option value="">Select</option>
                        {dataTypeMapping.map(x =>
                            <option value={x.id}>{x.name}</option>
                        )}
                    </select>
                </div>
                <div className="col-md-12 form-group">
                    <div className="table-responsive bg-white">
                        <table className="table align-items-center table-flush table-hover table-striped border">
                            <thead className="thead-light">
                                <tr>
                                    <th>Field</th>
                                    <th>DataTypes</th>
                                    <th>Replace Value</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allMapObjects.map((item) => (
                                    <tr>
                                        <td>{item.field}</td>
                                        <td>
                                            {item.replaceDataTypes.map(m =>
                                                <p>{m.attType}.{m.attObj}</p>
                                            )}
                                        </td>
                                        <td>
                                            {item.replaceDataTypes.map(m =>
                                                <p>{m.attValue} {m.attValue && m.attCommaSeperated && ","} <br /></p>
                                            )}
                                        </td>
                                        <td>
                                            <button className="btn btn-link btn-sm"
                                                onClick={() => handleDeleteMappItem(item)}>Delete</button>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-12 text-center">
                    <button className="btn btn-sm btn-outline-default" onClick={handleCloseMapping}>
                        <i className="fa fa-times" aria-hidden="true"></i> Close
                    </button>
                    <button className="btn btn-sm btn-outline-default"
                        disabled={allMapObjects.length === 0 || btnProcessStatus}
                        onClick={() => handleGenerate("generate")}>
                        {(btnProcessStatus && saveBtnType === "generate") ? <i className="fa fa-spinner fa-spin mr-2"></i>
                            : <i className="fa fa-cog mr-2" aria-hidden="true"></i>}
                        Generate and Save in Local Drive (PDF)
                    </button>

                    <button className="btn btn-sm btn-outline-default"
                        disabled={allMapObjects.length === 0 || btnProcessStatus}
                        onClick={() => handleGenerate("save")}
                    >
                        {(btnProcessStatus && saveBtnType === "save") ? <i className="fa fa-spinner fa-spin mr-2"></i>
                            : <i className="fa fa-cog mr-2" aria-hidden="true"></i>}
                        Generate and Save in DDRMS (PDF)
                    </button>
                </div>
            </div>}

        {newMappingShowHide && <AddDataTypeMapping app={app} applicantObj={applicantObj} handleAddNewMapping={handleAddNewMapping} />}

    </>

}

export default DataMapping;
